<div class="rmp-body" *ngIf="loaded">
  <router-outlet></router-outlet>
</div>
